export default {"src":"/_next/static/media/klown.6e721e17.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};